import React from 'react';
import { StyleSheet, View } from 'react-native';
import Theme from '../libs/Theme';
import LoadingIcon from '../icons/LoadingIcon';

export default function Loading({ color }) {
  return (
    <View style={styles.container}>
      <LoadingIcon color={color || Theme.color.magenta} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 100,
  },
});
